<template>
  <!-- needed ref="thead" to eliminate the vuesax error -->
  <tbody ref="thead">
    <vs-tr
      :data="tr"
      :key="indextr"
      v-for="(tr, indextr) in rows"
    >
      <vs-td>
        <p>
          <strong>{{ tr.name }}</strong>
        </p>
      </vs-td>
      <vs-td>
        <p>{{ tr.code }}</p>
      </vs-td>
      <vs-td class="whitespace-no-wrap">
        <div class="vx-row">
          <div class="vx-col w-auto">
            <span class="text-link text-primary">Details</span>
          </div>
          <div class="vx-col w-auto">
            <span v-if="$hasPermission('edit:locations')" class="text-link text-primary" @click.stop.prevent="processCloneLocation(tr)">Clone</span>
          </div>
        </div>
      </vs-td>
    </vs-tr>
  </tbody>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: ['rows'],
  computed: {
    ...mapState('visitManagement', ['location']),
  },
  methods: {
    clicktr (tr) {
      if (tr.permissions.edit) return this.$router.push({ name: 'edit-location', params: { id: tr.id } });
      if (this.$hasPermission('edit:locations'))
      return this.$router.push(`/location/${tr.id}/view`)
    }, // needed to eliminate the error this.$parent.clicktr
    async processCloneLocation(tr) {
      if (tr.permissions.edit) {
        this.$router.push({ path: `add-location`, query: { locationId: tr.id } });
      }
    },
  },
}
</script>
